<div id="operator-login" [class.operator-login-v2]="rideOpsUi.isV2Active$ | async">
	<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1Login">
		<div class="operator-login-v2-profile">
			<app-avatar
				[file]="operator.profileImage"
				[name]="operator.name"
				[userId]="operator.id"
				[size]="64"
			></app-avatar>
			<p class="operator-login-v2-name">{{ operator.name }}</p>
			<h2 class="operator-login-v2-title">{{ "OPERATORS_V2__ENTER_YOUR_PIN" | transloco }}</h2>
		</div>
		<app-pin-code-input (done)="login($event)"></app-pin-code-input>
	</ng-container>

	<ng-template #v1Login>
		<div class="avatar-container">
			<app-avatar
				[file]="operator.profileImage"
				[name]="operator.name"
				[userId]="operator.id"
				[size]="80"
			></app-avatar>
		</div>
		<app-pin-code-input (done)="login($event)"></app-pin-code-input>
	</ng-template>
</div>
